
 export const VERSION = '33';
 export const SERVER_API_URL = '/bmsapi/';
 export const BUILD_TIMESTAMP = '';
 export const DEBUG_INFO_ENABLED = !true;
 export const MAX_PAGE_SIZE = '10000';
 export const FILE_UPLOAD_SUPPORTED_TYPES = 'png,jpeg,jpg,pdf,json,csv,mpeg,tiff,bmp,gif,xls,xlsx,doc';
 export const FEEDBACK_ENABLED = 'false';
